import 'lazysizes';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import objectFitImages from 'object-fit-images';
import './menu';
import './search';
import './accordion';
import './accessibility';
import './accessibility-controls';
import './filter';
import './notices';
import './dialog';
import './bg-fade';
import './animations';
import './maps';
import './mega-list';
import './video';
gsap.registerPlugin(ScrollTrigger);

objectFitImages();

document.addEventListener('DOMContentLoaded', () => {
  /**
   * Initialize aria visibility toggles.
   *
   * Usage:
   *    <button aria-expanded="false" aria-controls="myDropdown">Toggle</button>
   *    <div id="myDropdown" aria-hidden="true">Dropdown</div>
   */
  document.querySelectorAll('[aria-controls]').forEach((el) => {
    el.addEventListener('click', (e) => {
      const id = el.getAttribute('aria-controls');
      const controlled = document.getElementById(id);
      const open = controlled.getAttribute('aria-hidden') !== 'false';

      controlled.setAttribute('aria-hidden', open ? 'false' : 'true');

      document.querySelectorAll(`[aria-controls="${id}"]`).forEach((el) => {
        el.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      e.preventDefault();
    });
  });
});

document.addEventListener('scroll', function (e) {
  if (window.scrollY > 100) {
    document.querySelector('#main').classList.add('is-scrolled-off-top');
  } else {
    document.querySelector('#main').classList.remove('is-scrolled-off-top');
  }
});

document.querySelectorAll('.block-link').forEach((el) => {
  el.addEventListener('click', function (e) {
    el.querySelector('a').click();
  });
});

// function fixedFooter() {
//   const container = document.querySelector('.site-container');
//   const footer = document.querySelector('.site-footer');
//   const footerHeight = footer.offsetHeight;
//   container.style.marginBottom = footerHeight + 'px';
// }

// document.addEventListener('DOMContentLoaded', () => {
//   fixedFooter();
// });

// window.addEventListener(
//   'resize',
//   function (event) {
//     fixedFooter();
//   },
//   true
// );
